<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M33.167 8a1.5 1.5 0 001.5 1.5h17.712l-29.44 29.44a1.5 1.5 0 002.122 2.12L54.5 11.622v17.712a1.5 1.5 0 103 0V8A1.5 1.5 0 0056 6.5H34.667a1.5 1.5 0 00-1.5 1.5zM8 17.167a1.5 1.5 0 00-1.5 1.5V56A1.5 1.5 0 008 57.5h37.333a1.5 1.5 0 001.5-1.5V45.333a1.5 1.5 0 10-3 0V54.5H9.5V20.167h9.167a1.5 1.5 0 000-3H8z"/></svg>